import { ReactNode } from 'react';

export interface IFragmentContainerProps {
  children?: ReactNode;
  visible?: boolean;
}

export const FragmentContainer = ({ children, visible = true }: IFragmentContainerProps) => {
  if (!visible) return <></>;
  return <>{children}</>;
};

export default FragmentContainer;
